import { EventQuery } from "lib/build/events";

export const queries: { [key: string]: EventQuery } = {
	status: {
		interpretation: { vocab: "basic_health", code: "patient_status" }
	},
	address: {
		interpretation: { vocab: "snomed", code: "184097001" }
	},
	weight: {
		interpretation: { vocab: "basic_health", code: "weight" }
	},
	ab0: {
		interpretation: { vocab: "basic_health", code: "ab0" }
	},
	rh: {
		interpretation: { vocab: "basic_health", code: "rh" }
	}
};
